import { message } from 'antd'
import apiClient from '../utils/apiClient'
import { actions } from './actionTypes'
import { setUploadState } from './index'

export const getUnsignedDocs = () => (dispatch, getState) => {
  const options = {
    method: 'GET',
    url: `${process.env.REACT_APP_API}/api/docs/unsigned`
  }

  apiClient(options).then(
    response =>
      dispatch({ type: actions.GET_UNSIGNED_DOCS, payload: response.data }),
    error => console.log(error)
  )
}

export const getUnsignedFileBlob = (mongoDbId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_API}/api/doc/unsigned/${mongoDbId}`,
      responseType: 'blob'
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}

// Builds the VPS acceptance-form export for a date range of signatures.
// Returns JSON ({ isin, valid, invalid }), not a file — the client constructs
// and downloads the .txt blob(s) itself so it can show invalid rows first.
export const getVpsExportData = (mongoDbId, { start, end, processed } = {}) => {
  const params = {}
  if (start) params.start = start
  if (end) params.end = end
  if (processed && processed !== 'all') params.processed = processed

  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_API}/api/doc/vps/${mongoDbId}`,
      params
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}

export const getAsExcelBlob = (mongoDbId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_API}/api/doc/excel/${mongoDbId}`,
      responseType: 'blob'
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}

// Uploads an Excel whitelist of VPS account numbers for a document. Resolves to
// the updated document (including the vpsSource column summary).
export const uploadVpsSource = (id, file) => {
  const form = new FormData()
  form.append('file', file)
  return apiClient.post(`${process.env.REACT_APP_API}/api/doc/unsigned/${id}/vps-source`, form).then(r => r.data)
}

// Removes the VPS whitelist Excel source (and any binding) from a document.
export const deleteVpsSource = (id) => {
  return apiClient.delete(`${process.env.REACT_APP_API}/api/doc/unsigned/${id}/vps-source`).then(r => r.data)
}

export const updateDocument = (id, data) => (dispatch, getState) => {
  const options = {
    method: 'PATCH',
    url: `${process.env.REACT_APP_API}/api/doc/unsigned/${id}`,
    data: data
  }

  apiClient(options).then(
    response => {
      dispatch({ type: actions.UNSIGNED_DOC_EDIT_SUCCESSFUL, payload: {
        id,
        data: response.data
      } })
      dispatch(setUploadState(true, response.status))
      message.success('Document updated successfully')
    },
    error => {
      const status = error.response && error.response.status
      const msg = error.response && error.response.data && error.response.data.message
      dispatch(setUploadState(false, status))
      message.error(msg ? `Could not update document: ${msg}` : 'Could not update document')
    }
  )
}

export const deleteDocument = (id) => (dispatch) => {
  const options = {
    method: 'DELETE',
    url: `${process.env.REACT_APP_API}/api/doc/unsigned/${id}`
  }

  apiClient(options).then(
    response => {
      dispatch({ type: actions.UNSIGNED_DOC_DELETE_SUCCESSFUL, payload: id })
      dispatch(setUploadState(true, response.status))
      message.success('Document deleted successfully')
    },
    error => {
      dispatch(setUploadState(false, error.response.status))
    }
  )
}
